"use strict";
angular.module('broadcastManageRouterModule', [])
    .config(['$stateProvider', function($stateProvider) {
        $stateProvider.state('manageconfig.productmanage.broadcast.manage', {
            url: '/manage?siteid',
            views: {
                'main@manageconfig.productmanage': {
                    templateUrl: './manageConfig/productManageMent/broadcast/blankPage/blankPage_tpl.html',
                    controller: ''
                }
            }
        })
        .state('manageconfig.productmanage.broadcast.manage.channelmanage', {
            url: '/channelmanage',
            views: {
                'main@manageconfig.productmanage.broadcast.manage': {
                    templateUrl: './manageConfig/productManageMent/broadcast/broadcastChannelManage/broadcastChannelManage_tpl.html',
                    controller: 'broadcastChannelManageCtrl'
                }
            }
        })
        .state('manageconfig.productmanage.broadcast.manage.distributionconfiguration', {
            url: '/distributionconfiguration', 
            views: {
                'main@manageconfig.productmanage.broadcast.manage': {
                    templateUrl: './manageConfig/productManageMent/broadcast/distributionconfiguration/distributionconfiguration_tpl.html',
                    controller: 'broadcastDistributionConfigurationCtrl'
                }
            }
        })
    }]);